import { render, staticRenderFns } from "./CancelacionesProcesadasDialog.vue?vue&type=template&id=506c9e9b&scoped=true"
import script from "./CancelacionesProcesadasDialog.vue?vue&type=script&lang=js"
export * from "./CancelacionesProcesadasDialog.vue?vue&type=script&lang=js"
import style0 from "./CancelacionesProcesadasDialog.vue?vue&type=style&index=0&id=506c9e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c9e9b",
  null
  
)

export default component.exports